module.exports = __webpack_public_path__ + "img/successlogo.2b7411fe.png";